









































































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BFormTextarea,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { SiteCreateModel } from "@/api/models/sites/site";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import appSettings from "@/appSettings";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormTextarea,
  },
  name: "create-site",
})
export default class CreateContact extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewSiteSidebarActive!: boolean;
  loading = false;

  required = required;

  newSite: SiteCreateModel = {};

  hasPlatform = appSettings.hasPlatform();

  resetForm() {
    this.newSite = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .createSiteEntreprise(this.$route.params.id, this.newSite)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un site",
            text: "Site créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-site");
        this.$emit("update:is-add-new-site-sidebar-active", false);
        this.loading = false;
        this.resetForm();
      });
  }
}
